import { useCallback, useState } from "react";
import { bulkDownloadFiles } from "@/services/api/categories";
import { toast } from "@/shared/lib/toast";
import type { FileItem } from "../types";

export function useBulkFileDownload() {
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadFiles = useCallback(async (files: FileItem[]) => {
    if (files.length === 0) return;

    setIsDownloading(true);
    try {
      const fileIds = files.map((f) => f.id);
      const blob = await bulkDownloadFiles(fileIds);

      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `files-${new Date().toISOString().slice(0, 10)}.zip`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    } catch {
      toast.error(
        "Download failed",
        "We couldn't download the files. Please try again."
      );
    } finally {
      setIsDownloading(false);
    }
  }, []);

  return { isDownloading, downloadFiles };
}
